<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">

        
        
        <Detail 
          :header="'Role Details'" 
          :values="values" 
          @edit="edit"
        />
        <TabMenu :model="nestedRouteItems" />
        <router-view v-if="role" :role="role" />

      </div>
    </div>
    
    <RolesForm
      :rolesForm="roleFormDialog"
      :reloadForm="reloadRoleForm"
      :disabledArr="[]"
      :roleToEdit="role"
      @close="roleFormDialog = false"
      @updated="updated"
    />
  </div>
</template>

<script>
import RoleService from "@/service/RoleService";
import Detail from "@/mbp/universalComponents/Detail.vue";
import RolesForm from '@/mbp/universalComponents/roles/RolesForm'

export default {
  created() {
    this.getRoleInfo()
  },
  components: {
    Detail,
    RolesForm
  },
  data() {
    return {
      roleService: new RoleService(),
      nestedRouteItems: [
        {
          label: "Details",
          icon: 'pi pi-info-circle',
          to: `/roles/${this.$route.params.roleid}/detail`,
        },
        {
          label: "Permissions",
          icon: 'pi pi-inbox',
          to: `/roles/${this.$route.params.roleid}/permissions`,
        }
      ],
      role: {},
      values: [],
      roleFormDialog: false,
      reloadRoleForm: 0,
    };
  },
  methods: {
    getRoleInfo() {
      // 
      this.roleService
        .getRoleById(this.$route.params.roleid)
        .then(data => {
          this.role = data
          console.log(data)  

          this.values = [
            {
              title: "Role Id:",
              description: this.role ? this.role.id : "",
            },
            {
              title: "Role Name:",
              description: this.role ? this.role.roleName : "",
            },
            {
              title: "Is Active:",
              description: this.role ? this.role.active ? "Yes" : "No" : "",
            },
            {
              title: "Created By:",
              description: this.role ? this.role.createdByName : "",
            }
          ]
        })
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting role info",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "roleInfo"'
          })
        })
    },
    updated(role) {
      
      this.roleFormDialog = false

      this.getRoleInfo()

      this.$toast.add({
        severity: "success",
        summary: "Success",
        detail: "role updated successfully",
        life: 5000,
      });
    },
    edit() {
      this.roleFormDialog = true
      this.reloadRoleForm++
    }
  }
}
</script>

<style>

</style>